import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { CustomerInfoContext } from '../../../contexts/CustomerInfoContext';
import { resources } from '../../../resources/resources';

export default function MyAccount() {
  const { t: translate } = useTranslation();
  const { customerInfo } = useContext(CustomerInfoContext);

  return (
    <div className="footer-my-account footer-nav">
      <ul>
        {customerInfo.canAccessMyCards && !customerInfo.isSavingsUser && (
          <li>
            <Link to="/my-account/cards">{translate(resources.cards)}</Link>
          </li>
        )}
        <li>
          <Link to="/my-account/orders">
            {translate(resources.menu.orders)}
          </Link>
        </li>
        {!customerInfo.isSavingsUser && (
          <li>
            <Link to="/my-account/subscriptions">
              {translate(resources.menu.subscriptions)}
            </Link>
          </li>
        )}
        <li>
          <Link to="/my-account/vouchers">
            {translate(resources.menu.vouchers)}
          </Link>
        </li>
        {!customerInfo.isSavingsUser && (
          <li>
            <Link to="/my-account/change-password">
              {translate(resources.menu.passwordChange)}
            </Link>
          </li>
        )}
      </ul>
    </div>
  );
}
